module.exports = __webpack_public_path__ + "img/img24.40096f07.svg";